import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';

import './../wizard.css';

class WizardButtons extends React.Component {
    constructor(props) {
        super(props);

        this.renderButton = this.renderButton.bind(this);
    }

    renderButton(button) {
        if (!button) return null;

        const { show, action, type, classes, message, onMouseDown } = button;
        if (!show) return null;

        let buttonProps = { className: classes, type: type, disabled: this.props.disabled, onMouseDown };
        if (type === 'button') {
            buttonProps = { ...buttonProps, disabled: false, onClick: action };
        }
        if (buttonProps.disabled === true) {
            buttonProps.className = `${buttonProps.className} disabled`;
        }

        return <button {...buttonProps}>{message}</button>;
    }

    render() {
        const { cancel, back, save, reject, submit, del } = this.props;

        return (
            <div className="row wizard-buttons">
                <div className="col-xs-12">
                    {back && this.renderButton({ ...defaults.back, ...back })}
                    {cancel && this.renderButton({ ...defaults.cancel, ...cancel })}
                    {submit && this.renderButton({ ...defaults.submit, ...submit })}
                    {reject && this.renderButton({ ...defaults.reject, ...reject })}
                    {save && this.renderButton({ ...defaults.save, ...save })}
                    {del && this.renderButton({ ...defaults.del, ...del })}
                </div>
            </div>
        );
    }
}

export const defaults = {
    cancel: { show: true, type: 'button', action: () => null, classes: 'wizard-cancel', message: <FormattedMessage {...messages.cancel} /> },
    back: { show: true, type: 'button', action: () => null, classes: 'wizard-backward', message: <FormattedMessage {...messages.back} /> },
    save: { show: true, type: 'button', action: () => null, classes: 'wizard-save', message: <FormattedMessage {...messages.save} /> },
    reject: { show: true, type: 'button', action: () => null, classes: 'wizard-reject', message: <FormattedMessage {...messages.reject} /> },
    submit: { show: true, type: 'submit', classes: 'wizard-submit', message: <FormattedMessage {...messages.continue} /> },
    del: { show: true, type: 'submit', classes: 'wizard-reject', message: <FormattedMessage {...messages.delete} /> }
};

WizardButtons.defaultProps = {
    cancel: undefined,
    back: undefined,
    save: undefined,
    reject: undefined,
    delete: undefined,
    submit: { show: true, type: 'submit', classes: 'wizard-submit', message: <FormattedMessage {...messages.continue} /> },
    disabled: false
};
WizardButtons.propTypes = {
    cancel: PropTypes.object,
    back: PropTypes.object,
    save: PropTypes.object,
    reject: PropTypes.object,
    submit: PropTypes.object,
    disabled: PropTypes.bool
};

export default WizardButtons;



// WEBPACK FOOTER //
// ./src/components/wizard/navigator/buttons.jsx